import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Input } from 'semantic-ui-react';

import { injectIntl } from 'react-intl';
import { Icon } from '@plone/volto/components';

import FormFieldWrapper from '../FormFieldWrapper';

class TextWidget extends Component {
  static propTypes = {
    id: PropTypes.string.isRequired,
    type: PropTypes.string,
    title: PropTypes.string,
    description: PropTypes.string,
    required: PropTypes.bool,
    error: PropTypes.arrayOf(PropTypes.string),
    value: PropTypes.string,
    focus: PropTypes.bool,
    onChange: PropTypes.func,
    onBlur: PropTypes.func,
    onClick: PropTypes.func,
    onEdit: PropTypes.func,
    onDelete: PropTypes.func,
    icon: PropTypes.shape({
      xmlns: PropTypes.string,
      viewBox: PropTypes.string,
      content: PropTypes.string,
    }),
    iconAction: PropTypes.func,
    minLength: PropTypes.number,
    maxLength: PropTypes.number,
    wrapped: PropTypes.bool,
    placeholder: PropTypes.string,
    control: PropTypes.any,
    isDisabled: PropTypes.bool,
  };

  static defaultProps = {
    type: 'text',
    title: '',
    description: null,
    required: false,
    error: [],
    value: null,
    onChange: () => {},
    onBlur: () => {},
    onClick: () => {},
    onEdit: null,
    onDelete: null,
    focus: false,
    icon: null,
    iconAction: null,
    minLength: null,
    maxLength: null,
    isDisabled: false,
  };

  componentDidMount() {
    if (this.props.focus) {
      this.node.focus();
    }
  }

  render() {
    const {
      id,
      type,
      value,
      onChange,
      onBlur,
      onClick,
      icon,
      iconAction,
      minLength,
      maxLength,
      placeholder,
      isDisabled,
    } = this.props;
    return (
      <FormFieldWrapper {...this.props} className="text">
        <Input
          id={`field-${id}`}
          className="rw--text-widget"
          name={id}
          type={type}
          value={value || (type === 'number' ? 0 : '')}
          disabled={isDisabled}
          icon={icon || null}
          placeholder={placeholder}
          onChange={({ target }) => {
            // SemanticUIReact and React are bugged on Safari, input type is disregarded
            // type number always allows for chars, this fixes it but slowes down the UI
            // ... A LOT! #safariisthenewIE
            if (type === 'number') {
              if (/[0-9]/.test(target.value) || !target.value) {
                onChange(id, target.value === '' ? undefined : target.value);
              }
            } else onChange(id, target.value === '' ? undefined : target.value);
          }}
          ref={(node) => {
            this.node = node;
          }}
          onBlur={({ target }) =>
            onBlur(id, target.value === '' ? undefined : target.value)
          }
          onClick={() => onClick()}
          minLength={minLength || null}
          maxLength={maxLength || null}
        />
        {icon && iconAction && (
          <button className={`field-${id}-action-button`} onClick={iconAction}>
            <Icon name={icon} size="18px" />
          </button>
        )}
      </FormFieldWrapper>
    );
  }
}

export default injectIntl(TextWidget);
